import { motion } from "framer-motion";

const items = [
  {
    n: "01",
    title: "Increase Food Revenue",
    body: "Re-engineer the menu, pricing and pour costs so kitchens contribute to profit — not drag it.",
  },
  {
    n: "02",
    title: "Improve Guest Retention",
    body: "Systems that make the second visit inevitable — reservations, hosts, personalisation.",
  },
  {
    n: "03",
    title: "Reduce Operating Costs",
    body: "Audit shift structures, inventory shrink and vendor terms — recover margin quietly.",
  },
  {
    n: "04",
    title: "Increase Staff Productivity",
    body: "SOPs, training and incentive design that turn service teams into revenue teams.",
  },
  {
    n: "05",
    title: "Improve Customer Experience",
    body: "The 90-minute guest journey — light, sound, service, story — engineered end to end.",
  },
  {
    n: "06",
    title: "Increase Repeat Business",
    body: "Build the loyalty engine most venues never install: data, cohorts, reactivation.",
  },
];

export default function WhyMe() {
  return (
    <section
      id="why"
      data-testid="why-section"
      className="relative py-20 md:py-40 bg-[#030303]"
    >
      <div className="max-w-[1440px] mx-auto px-6 md:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-16 items-end mb-14 md:mb-24">
          <div className="lg:col-span-8">
            <div className="text-[11px] uppercase tracking-[0.28em] text-[#D4AF37] mb-5">
              Ch. 04 &mdash; Why work with me
            </div>
            <h2 className="font-display text-white text-[30px] sm:text-4xl md:text-6xl lg:text-[80px] leading-[1.02] sm:leading-[0.98] tracking-[-0.02em]">
              Most nightclubs don't have a{" "}
              <em className="font-editorial italic text-white/40 font-light">
                marketing problem.
              </em>
              <br />
              They have a{" "}
              <em className="font-editorial italic text-[#D4AF37] font-light">
                profitability problem.
              </em>
            </h2>
          </div>
          <div className="lg:col-span-4 text-white/60 text-sm md:text-base leading-relaxed lg:pl-6">
            The best marketing amplifies a great venue. The worst marketing
            amplifies a leaking one. We start by fixing the venue.
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-px bg-white/8 rounded-2xl overflow-hidden border border-white/8">
          {items.map((it, i) => (
            <motion.div
              key={it.n}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.15 }}
              transition={{ duration: 0.7, delay: (i % 3) * 0.1 }}
              data-testid={`why-card-${it.n}`}
              className="group relative p-6 sm:p-8 md:p-10 bg-[#050505] hover:bg-[#0a0a0a] transition-colors duration-500 min-h-[200px] md:min-h-[240px] flex flex-col"
            >
              <div className="flex items-start justify-between">
                <span className="font-display text-[#D4AF37]/80 text-sm tracking-[0.2em]">
                  {it.n}
                </span>
                <span className="opacity-0 group-hover:opacity-100 transition-opacity duration-500 text-[#D4AF37]">
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                    <path
                      d="M7 17L17 7M17 7H8M17 7v9"
                      stroke="currentColor"
                      strokeWidth="1.6"
                    />
                  </svg>
                </span>
              </div>
              <h3 className="mt-6 sm:mt-8 font-display text-white text-xl sm:text-2xl md:text-[28px] leading-tight">
                {it.title}
              </h3>
              <p className="mt-3 sm:mt-4 text-white/60 text-sm md:text-[15px] leading-relaxed flex-1">
                {it.body}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
